<template>
    <div class="adaptive-modal-footer">
        <button v-if="isCancelVisible" type="button" class="btn btn-secondary" @click="$emit('cancel')" :disabled="isCancelDisabled">
            {{ cancelText }}
        </button>
        <button type="button" class="btn btn-primary" @click="$emit('save')" :disabled="isSaveDisabled">
            {{ saveText }}
        </button>
    </div>
</template>

<script>
export default {
    name: "AdaptiveModalFooter",
    props: {
        cancelText: {
            type: String,
            default: "Cancel",
        },
        saveText: {
            type: String,
            default: "Save",
        },
        isSaveDisabled: {
            type: Boolean,
            default: false,
        },
        isCancelDisabled: {
            type: Boolean,
            default: false,
        },
        isCancelVisible: {
            type: Boolean,
            default: true,
        },
    },
    emits: ["cancel", "save"],
};
</script>

<style scoped>
.adaptive-modal-footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 1rem;
    border-top: 1px solid var(--input-border); /* Assuming var(--input-border) is defined */
    gap: 0.5rem; /* Space between buttons */
}
</style> 